<template>

	<div class="cfb__container">

		<div class="cfb__header">
			<input type="search" name="search" :placeholder="t.search" v-model="search">
		</div>

		<transition-group name="slide-fade" tag="ul" class="cfb__templates">
			<li :class="['cfb__template', {'cfb__template--open': theme.id == activeTheme}]" v-for="theme in themesFiltered" :key="theme.id">
				<div class="cfb__template__header" @click="collapse(theme.id)">
					<div>
						<h1 class="cfb__text--primary">{{ theme.desc }}</h1>
						<div>
							<p>{{ theme.long_desc }}</p>
							<a @click.stop :href="theme.url" target="_blank" rel="noreferrer" class="cfb__button--preview">{{ t.preview }}</a>
						</div>
					</div>
					<div>
						<button class="cfb__button">
							<span>{{ t.label_funnel_blueprint }}</span>
						</button>
						<span class="cfb__separator"></span>
						<b class="cfb__text--primary">{{ blueprints.length }}</b>
						<span>{{ t.label_available }}</span>
					</div>
				</div>
				<div class="cfb__template__collapse" v-if="theme.id == activeTheme">
					<ul class="cfb__template__blueprints">
						<li class="cfb__template__blueprint" v-for="blueprint in blueprints" :key="blueprint.id">
							<div :style="{backgroundImage: `url(${imagesPath+blueprint.img})`}"></div>
							<span class="cfb__separator"></span>
							<div>
								<h2>{{ blueprint.desc }}</h2>
								<p>{{ blueprint.long_desc }}</p>
							</div>
							<div>
								<a class="cfb__button" :href="`${routeFunnelBuilder}?theme=${activeTheme}&blueprint=${blueprint.id}`" target="_blank">
									<span>{{ t.label_funnel_open }}</span>
								</a>
							</div>
						</li>
					</ul>
				</div>
			</li>
		</transition-group>

	</div>

</template>


<script>

export default {
	props: {
		t: Object, // translations
		locale: String,
		routeFunnelBuilder: String,
	},

	data: () => {
		return {
			activeTheme: null,
			search: '',
			themes: [],
			blueprints: []
		}
	},

	mounted() {
		this.index()
	},

	methods: {

		collapse: function(item) {
			this.activeTheme = this.activeTheme == item ? null : item
			this.$nextTick(() => {
				if (this.activeTheme) {
					document.querySelector('.cfb__template--open').scrollIntoView({behavior: 'smooth'});
				}
			})
		},

		index: function() {
			let vm = this;
			fetch(this.apiUri)
				.then((resp) => resp.json())
				.then((data) => {
					if (data.success) {
						vm.blueprints = data.blueprints
						vm.themes = data.themes
					}
				})
		}
	},

	computed: {

		themesFiltered: function() {
			if (!this.search || !this.themes.length) return this.themes
			return this.themes.filter(theme => {
                return theme.desc.toLowerCase().includes(this.search.toLowerCase())
            })
		},

		imagesPath() {
			return 'https://sitebuilder-admin.omb11.com/storage/';
		},

		apiUri() {
			return 'https://cheetah-api.builderall.com/data-themes-and-blueprints/'+this.locale;
		},
	}
}
</script>


<style scoped lang="scss">

.cfb__container {

	max-width: 1000px;
	margin: auto;
	padding: 2%;

	* {
		font-family: 'Mulish', sans-serif;
		color: #5B5B5B;
	}

	.cfb__text--primary {
		color: #7E1AFD;
	}
	h1 {
		margin: 10px 0;
		font-weight: 600;
		font-size: 24px;
	}
	h2 {
		font-weight: normal;
		font-size: 22px;
		line-height: 28px;
		margin: 10px 0;
	}
	p {
		margin: 0;
		font-size: 14px;
		line-height: 18px;
	}

	.cfb__button {
		display: flex;
	    align-items: center;
	    font-size: 22px;
	    border: none;
    	background-color: transparent;
    	min-height: 44px;
    	padding-left: 33px;
    	background-repeat: no-repeat;
    	border-radius: 4px;
    	min-width: 120px;
    	text-align: center;
    	background-image: url("data:image/svg+xml,%3Csvg width='33' height='44' viewBox='0 0 33 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.16056 0V5.78748C8.16056 7.09745 7.09862 8.15939 5.78865 8.15939H0.0012207L8.16056 0Z' fill='%237E1AFD'/%3E%3Cpath d='M30.1678 0H9.53025V5.78669C9.53025 7.85045 7.85049 9.53025 5.78673 9.53025H0V41.5081C0 42.8176 1.06272 43.8804 2.37226 43.8804H30.1678C31.4705 43.8804 32.54 42.8176 32.54 41.5081V2.37226C32.54 1.06272 31.4705 0 30.1678 0ZM26.8591 29.505C26.8591 29.8926 26.545 30.2067 26.1574 30.2067H21.7132C21.3256 30.2067 21.0114 29.8926 21.0114 29.505V26.0886C21.0114 25.7011 21.3256 25.3869 21.7132 25.3869H23.1893V22.3196H16.9565V23.8121H18.5109C18.8985 23.8121 19.2127 24.1263 19.2127 24.5139V26.68C19.2127 27.0675 18.8985 27.3817 18.5109 27.3817H16.9565V31.6654H18.5109C18.8985 31.6654 19.2127 31.9796 19.2127 32.3671V35.7835C19.2127 36.171 18.8985 36.4852 18.5109 36.4852H14.0667C13.6791 36.4852 13.3649 36.171 13.3649 35.7835V32.3671C13.3649 31.9796 13.6791 31.6654 14.0667 31.6654H15.5852V27.3817H14.0667C13.6791 27.3817 13.3649 27.0675 13.3649 26.68V24.5139C13.3649 24.1263 13.6791 23.8121 14.0667 23.8121H15.5852V22.3196H9.35239V25.3869H10.8284C11.216 25.3869 11.5301 25.7011 11.5301 26.0886V29.505C11.5301 29.8926 11.216 30.2067 10.8284 30.2067H6.38414C5.99655 30.2067 5.6824 29.8926 5.6824 29.505V26.0886C5.6824 25.7011 5.99655 25.3869 6.38414 25.3869H7.98113V21.5735C7.98113 21.2279 8.26071 20.9483 8.60624 20.9483H15.5852V18.228L11.8285 14.4713C11.4938 14.1366 11.4938 13.5939 11.8285 13.2592L15.6632 9.4245C15.998 9.08976 16.5406 9.08976 16.8754 9.4245L20.7137 13.2629C21.0485 13.5976 21.0485 14.1403 20.7137 14.475L16.9565 18.2323V20.9483H23.9354C24.281 20.9483 24.5606 21.2279 24.5606 21.5734V25.3869H26.1574C26.545 25.3869 26.8591 25.701 26.8591 26.0886V29.505H26.8591Z' fill='%237E1AFD'/%3E%3C/svg%3E%0A");
    	&:hover {
    		background-color: rgba(196, 196, 196, 0.29);
    	}
    	span {
    		margin: 0 10px;
    		width: 100%;
    	}
	}

	.cfb__button--preview {
		background: rgba(218, 223, 237, 0.5);
		border-radius: 4px;
		color: #0080FC;
		font-size: 14px;
		padding: 8px 20px;
		transition: .3s background;
		&:hover {
			background: #0080FC;
			color: #fff;
		}
	}

	.cfb__header {
		display: flex;
		justify-content: flex-end;
		margin-bottom: 1rem;

		input {
			background: transparent;
		    border: none;
		    padding: 12px 10px 12px 50px;
		    max-width: 400px;
		    background-image: url("data:image/svg+xml,%0A%3Csvg width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.793 12.968L11.872 10.047C11.8064 9.98142 11.7284 9.92951 11.6425 9.89432C11.5567 9.85913 11.4647 9.84135 11.372 9.84202H10.9C11.8527 8.61901 12.3032 7.07868 12.1595 5.53503C12.0159 3.99138 11.2889 2.56062 10.1268 1.53443C8.96475 0.508242 7.45504 -0.0361209 5.90548 0.012314C4.35591 0.060749 2.88315 0.698335 1.78742 1.7951C0.691699 2.89186 0.0555052 4.36522 0.00853563 5.91483C-0.038434 7.46445 0.507357 8.97364 1.53464 10.1347C2.56193 11.2959 3.99337 12.0215 5.53716 12.1637C7.08095 12.3059 8.62086 11.8539 9.84296 10.9V11.377C9.84229 11.4698 9.86007 11.5618 9.89526 11.6476C9.93045 11.7334 9.98236 11.8114 10.048 11.877L12.969 14.798C13.034 14.8635 13.1114 14.9154 13.1966 14.9509C13.2818 14.9863 13.3732 15.0046 13.4655 15.0046C13.5577 15.0046 13.6491 14.9863 13.7343 14.9509C13.8195 14.9154 13.8969 14.8635 13.962 14.798L14.791 13.969C14.857 13.9035 14.9095 13.8257 14.9454 13.7398C14.9813 13.654 14.9998 13.5619 15 13.4689C15.0002 13.3759 14.982 13.2838 14.9465 13.1978C14.9109 13.1118 14.8588 13.0338 14.793 12.968ZM6.09296 9.84202C5.35128 9.84202 4.62625 9.62208 4.00957 9.21003C3.39288 8.79797 2.91224 8.2123 2.62841 7.52708C2.34458 6.84186 2.27032 6.08786 2.41501 5.36043C2.55971 4.633 2.91686 3.96481 3.44131 3.44037C3.96575 2.91592 4.63394 2.55877 5.36137 2.41407C6.0888 2.26938 6.8428 2.34364 7.52802 2.62747C8.21324 2.9113 8.79891 3.39194 9.21097 4.00863C9.62302 4.62531 9.84296 5.35034 9.84296 6.09202C9.84348 6.58467 9.74685 7.07259 9.5586 7.52785C9.37034 7.98312 9.09415 8.39679 8.74584 8.74519C8.39753 9.0936 7.98393 9.36989 7.52872 9.55827C7.0735 9.74665 6.58561 9.84341 6.09296 9.84302V9.84202Z' fill='%23434343'/%3E%3C/svg%3E%0A");
		    background-repeat: no-repeat;
		    background-position: 15px center;
		    background-size: 17px;
		    border-bottom: 1px solid #C6C2C2;
		    text-align: center;
		    font-size: .9rem;
		}
	}

	.cfb__templates {
		margin-top: 45px;
		.cfb__template {
			position: relative;
			&:not(.cfb__template--open) {
				&:before, &:after {
				    content: close-quote;
				    position: absolute;
				    background: #FFFFFF;
					box-shadow: 0px 4px 4px rgba(38, 36, 36, 0.161);
				    height: 100%;
				    z-index: 0;
				    border-radius: 4px;
				}
				&:before {
					top: 18px;
					width: calc(100% - 60px);
					left: 30px;
				}
				&:after {
					width: calc(100% - 30px);
					top: 9px;
	    			left: 15px;
				}
				.cfb__template__header {
					margin-bottom: 2rem;
				}
			}
			&.cfb__template--open {
				.cfb__button--preview {
					display: block !important;
				}
			}
			.cfb__template__header {
				background: #FFFFFF;
				box-shadow: 0px 4px 4px rgba(38, 36, 36, 0.161);
				border-radius: 4px;
				margin-bottom: 1rem;
				display: flex;
				padding: 15px;
				min-height: 100px;
				position: relative;
				z-index: 1;
				cursor: pointer;
				user-select: none;

				@media screen and (max-width: 576px) {
					flex-direction: column;
					> div {
						margin: 10px 0;
						border: none !important;
					}
				}

				> div {
					flex: 1;
					display: flex;
					align-items: center;

					&:nth-child(1) {
						flex-grow: 2;
						border-right: 1px solid rgba(0, 0, 0, 0.4);
						justify-content: space-between;
						p {
							text-align: right;
							font-family: Muli-Regular;
						}
						h1 {
							margin: 0 10px;
							@media screen and (min-width: 576px) {
								min-width: 160px;
							}
						}
						h2 {
							margin: 10px;
						}
						div {
							margin: 0 18px;
							display: flex;
						    flex-direction: column;
						    align-items: flex-end;
						    a {
						    	margin-top: 5px;
						    	display: none;
						    }
						}
					}
					&:nth-child(2) {
						display: flex;
					    justify-content: center;
					    align-items: center;
						padding: 0 10px;
					    .cfb__separator {
					    	border-right: 1px solid rgba(0, 0, 0, 0.4);
					    	height: 35px;
    						margin: 0 12px;
					    }
					    b.cfb__text--primary {
					    	margin: 0 10px;
					    	font-weight: 700;
					    	font-size: 24px;

					    }
					}
					
				}
			}

			.cfb__template__collapse {
				.cfb__template__blueprints {
					margin: 15px;
					.cfb__template__blueprint {
						background: #FFFFFF;
						border-radius: 4px;
						margin-bottom: 8px;
						display: flex;
						align-items: center;
						padding: 10px;

						@media screen and (max-width: 576px) {
							flex-direction: column;
							.cfb__separator {
								display: none;
							}
						}

						div {

                            // image
							&:nth-of-type(1) {
								margin: 0px 40px;
                                width: 260px;
                                height: 150px;
                                background-color: #e9edf1;
                                background-origin: border-box;
                                background-position: center;
                                background-size: contain;
                                background-repeat: no-repeat;
                            }

                            // desc
							&:nth-of-type(2) {
								padding: 0 20px 15px 20px;
								flex: 1;
								p {
									font-family: Muli-Regular;
								}
							}

                            // button
							&:nth-of-type(3) {
								padding: 30px;
								font-weight: 600;
							}
						}
						.cfb__separator {
							border-right: 1px solid rgba(0, 0, 0, 0.4);
							height: 77px;
						}
					}
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/funnel-club/CheetahFunnelBuilderTemplates.vue